// extracted by mini-css-extract-plugin
module.exports =  {"link":"bGVFWuS","icon":"GgJMF2u"};